export var getSrcUrl = function getSrcUrl(tunnels, extensionResource, defaultUrl) {
  var matchTunnel = tunnels.find(function (tunnel) {
    return tunnel.resourceKey === extensionResource;
  });
  if (matchTunnel) {
    return matchTunnel.tunnelUrl;
  }
  return defaultUrl;
};